
Object.assign(window.FazendaRP.Pages.financeiro, {

    renderFluxoCaixa: async function (container) {
        // 1. Initial Loading State
        container.innerHTML = `
            <div style="text-align:center; padding:50px;">
                <i class="fas fa-spinner fa-spin fa-2x" style="color:#0f172a;"></i>
                <p style="margin-top:15px; color:#64748b;">Carregando Fluxo de Caixa...</p>
            </div>
        `;

        // 2. Structure (Based on Mockup)
        // We'll replace the innerHTML later with the dashboard structure.

        // 3. Dates (Default: Current Month)
        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];

        // 4. Fetch Data & Render
        // We define a helper to refresh just the content to avoid re-rendering the whole shell if not needed,
        // but for simplicity, we'll re-render the whole view on filter change or init.
        this.loadAndRenderFluxo(container, startOfMonth, endOfMonth);
    },

    loadAndRenderFluxo: async function (container, startDate, endDate) {
        console.log('🚀 INICIANDO FLUXO DE CAIXA', { startDate, endDate });
        try {
            // A. Fetch Realized (Movimentações) - All time up to EndDate?
            // First, get all accounts to filter by type
            const { data: allAccounts } = await window.FazendaRP.supabase
                .from('financeiro_contas')
                .select('id, tipo');

            const cartaoIds = (allAccounts || [])
                .filter(a => a.tipo === 'Cartão de Crédito')
                .map(a => a.id);

            const { data: allMovsRaw, error: errMov } = await window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .select('id, data_operacao, valor, tipo, historico, conta_id, financeiro_lancamentos(descricao, num_doc)')
                .order('data_operacao');

            if (errMov) throw errMov;

            // Filter out Credit Card movements in JavaScript
            const allMovs = (allMovsRaw || []).filter(m => !cartaoIds.includes(m.conta_id));

            // DEBUG: Check if filter is working
            console.log('📊 Total movimentações:', allMovsRaw?.length || 0);
            console.log('📊 Após filtrar cartão:', allMovs?.length || 0);
            console.log('📊 IDs de Cartão:', cartaoIds);

            // B. Fetch Projected (Lançamentos Pendentes + Cartão Não Quitado)
            // Include:
            // 1. All pending (status != Pago)
            // 2. Credit card purchases (status = Pago, but money hasn't left bank yet)
            const { data: allPendingRaw, error: errPen } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('id, data_vencimento, valor, tipo, descricao, num_doc, status, conta_id');

            if (errPen) throw errPen;

            // Filter: Include if (status != Pago) OR (status = Pago AND conta is Credit Card)
            const allPending = (allPendingRaw || []).filter(p => {
                if (p.status !== 'Pago') return true; // All non-paid
                return cartaoIds.includes(p.conta_id); // Paid with credit card
            });

            console.log('📊 Total lançamentos:', allPendingRaw?.length || 0);
            console.log('📊 Projetados (incluindo cartão):', allPending?.length || 0);

            // C. Process Data
            // We need to merge them into a single timeline.
            // 1. Calculate Saldo Inicial (Sum of all Movs BEFORE startDate)
            let saldoInicial = 0;
            const realizedInPeriod = [];
            const projectedInPeriod = [];

            // Helper for Date Comparison
            const isBefore = (d1, d2) => d1 < d2;
            const isBetween = (d, start, end) => d >= start && d <= end;

            // Process Realized
            allMovs.forEach(m => {
                // Adjust Sign
                const val = m.tipo === 'CREDITO' ? Math.abs(m.valor) : -Math.abs(m.valor);

                if (isBefore(m.data_operacao, startDate)) {
                    saldoInicial += val;
                } else if (isBetween(m.data_operacao, startDate, endDate)) {
                    realizedInPeriod.push({
                        data: m.data_operacao,
                        tipo: m.tipo === 'CREDITO' ? 'Receita' : 'Despesa',
                        doc: m.financeiro_lancamentos?.num_doc || '-',
                        desc: m.financeiro_lancamentos?.descricao || m.historico || 'Movimentação',
                        valor: val,
                        status: 'Realizado'
                    });
                }
            });

            // Process Projected (Only those in period)
            // Note: Projected items BEFORE startDate that are still pending should be considered "Overdue" and affect the flow if we want to show them?
            // Usually Cash Flow shows "What will happen".
            // If something was due yesterday and wasn't paid, it technically should have happened yesterday?
            // Or it happens Today?
            // Let's stick to their original due date for the chart, effectively showing them in the past (if start date covers it).
            // If they are before StartDate, they won't show in the chart/table, effectively ignoring them for the *period's* flow,
            // BUT they represent a liability/asset that "should have happened".
            // Typically, past due items are shown as "Immediate" or "Today" or simply listed on their original date.
            // Let's filter by Period for the Table/Chart.

            allPending.forEach(p => {
                if (isBetween(p.data_vencimento, startDate, endDate)) {
                    // Sign
                    const val = p.tipo === 'Receita' ? Math.abs(p.valor) : -Math.abs(p.valor);

                    projectedInPeriod.push({
                        data: p.data_vencimento,
                        tipo: p.tipo,
                        doc: p.num_doc || '-',
                        desc: p.descricao || 'Lançamento Futuro',
                        valor: val,
                        status: 'Projetado'
                    });
                }
            });

            // D. Merge and Sort
            let combined = [...realizedInPeriod, ...projectedInPeriod];
            combined.sort((a, b) => a.data.localeCompare(b.data));

            // E. Calculate Running Balance
            let currentSaldo = saldoInicial;
            let totalEntradas = 0;
            let totalSaidas = 0;

            const tableRows = combined.map(item => {
                currentSaldo += item.valor;
                if (item.valor > 0) totalEntradas += item.valor;
                else totalSaidas += item.valor;

                return {
                    ...item,
                    saldoAcumulado: currentSaldo
                };
            });

            const saldoFinal = currentSaldo;

            // F. Render HTML
            this.renderFluxoView(container, startDate, endDate, saldoInicial, totalEntradas, totalSaidas, saldoFinal, tableRows);

        } catch (err) {
            console.error(err);
            container.innerHTML = `<div style="color:red; text-align:center; padding:20px;">Erro ao carregar dados: ${err.message}</div>`;
        }
    },

    renderFluxoView: function (container, startDate, endDate, saldoInicial, entradas, saidas, saldoFinal, rows) {

        // CSS Styles from Mockup (Injected inline or via style tag)
        // We will stick to inline styles for simplicity as per user preference in previous tasks, 
        // or re-use the app's CSS.
        // The mockup defines specific styles. I will try to adapt them to the container.

        const formatBRL = val => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const formatDate = d => d.split('-').reverse().join('/');

        const html = `
            <style>
                 /* Scoped simply by class names */
                .fluxo-kpi-grid {
                    display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px;
                    margin-bottom: 20px;
                }
                .fluxo-kpi-card {
                    background: white; padding: 15px; border-radius: 8px; border: 1px solid #e2e8f0;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }
                .fluxo-kpi-label { font-size: 0.75rem; color: #64748b; font-weight: 600; text-transform: uppercase; margin-bottom: 5px; }
                .fluxo-kpi-value { font-size: 1.5rem; font-weight: 700; color: #0f172a; }
                .fluxo-val-pos { color: #166534; }
                .fluxo-val-neg { color: #dc2626; }
                
                .fluxo-badge { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; font-weight: 600; }
                .fluxo-badge-receita { background: #dcfce7; color: #166534; }
                .fluxo-badge-despesa { background: #fee2e2; color: #991b1b; }
                .fluxo-badge-projetado { border: 1px dashed #64748b; color: #64748b; margin-left:5px; }
            </style>

            <!-- Header & Filter -->
            <div style="background:white; padding:20px; border-radius:8px; border:1px solid #e2e8f0; margin-bottom:20px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px;">
                <div>
                     <h2 style="margin:0; font-size:1.25rem; color:#0f172a;">Fluxo de Caixa</h2>
                     <div style="font-size: 0.85rem; color: #64748b;">Realizado vs Projetado</div>
                </div>
                <div style="display:flex; gap:10px; align-items:flex-end;">
                    <div>
                        <label style="font-size:0.75rem; font-weight:600; color:#64748b; display:block; margin-bottom:2px;">De</label>
                        <input type="date" id="fluxo-start" value="${startDate}" class="form-control" style="padding:6px; font-size:0.9rem;">
                    </div>
                    <div>
                        <label style="font-size:0.75rem; font-weight:600; color:#64748b; display:block; margin-bottom:2px;">Até</label>
                        <input type="date" id="fluxo-end" value="${endDate}" class="form-control" style="padding:6px; font-size:0.9rem;">
                    </div>
                    <button id="btn-update-fluxo" class="btn btn-primary" style="height:36px;"><i class="fas fa-filter"></i> Filtrar</button>
                </div>
            </div>

            <!-- KPIs -->
            <div class="fluxo-kpi-grid">
                <div class="fluxo-kpi-card">
                    <div class="fluxo-kpi-label">Saldo Inicial (Período)</div>
                    <div class="fluxo-kpi-value">${formatBRL(saldoInicial)}</div>
                </div>
                <div class="fluxo-kpi-card">
                    <div class="fluxo-kpi-label">Entradas Previstas/Real.</div>
                    <div class="fluxo-kpi-value fluxo-val-pos">${formatBRL(entradas)}</div>
                </div>
                <div class="fluxo-kpi-card">
                    <div class="fluxo-kpi-label">Saídas Previstas/Real.</div>
                    <div class="fluxo-kpi-value fluxo-val-neg">${formatBRL(saidas)}</div>
                </div>
                <div class="fluxo-kpi-card" style="background:#f0fdf4; border-color:#bbf7d0;">
                    <div class="fluxo-kpi-label">Saldo Final (Período)</div>
                    <div class="fluxo-kpi-value fluxo-val-pos">${formatBRL(saldoFinal)}</div>
                </div>
            </div>

            <!-- Chart -->
            <div style="background:white; padding:20px; border-radius:8px; border:1px solid #e2e8f0; margin-bottom:20px; height:350px;">
                <canvas id="fluxoMainChart"></canvas>
            </div>

            <!-- Table -->
            <div style="background:white; border-radius:8px; border:1px solid #e2e8f0; overflow:hidden;">
                <div style="overflow-x:auto;">
                    <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                        <thead>
                            <tr style="background:#f8fafc; border-bottom:1px solid #e2e8f0; text-align:left; color:#475569; text-transform:uppercase; font-size:0.75rem;">
                                <th style="padding:12px 20px;">Data</th>
                                <th style="padding:12px 20px;">Status</th>
                                <th style="padding:12px 20px;">Tipo</th>
                                <th style="padding:12px 20px;">Descrição</th>
                                <th style="padding:12px 20px; text-align:right;">Valor</th>
                                <th style="padding:12px 20px; text-align:right;">Saldo</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows.map(r => `
                                <tr style="border-bottom:1px solid #f1f5f9; ${r.status === 'Projetado' ? 'background:white;' : 'background:#fcfcfc; color:#555;'}">
                                    <td style="padding:12px 20px; color:#64748b;">${formatDate(r.data)}</td>
                                    <td style="padding:12px 20px;">
                                        ${r.status === 'Projetado'
                ? '<span style="font-size:0.7rem; background:#f1f5f9; color:#64748b; padding:2px 6px; border-radius:4px; border:1px dashed #cbd5e1;">Projetado</span>'
                : '<span style="font-size:0.7rem; background:#ecfdf5; color:#047857; padding:2px 6px; border-radius:4px; font-weight:600;">Realizado</span>'}
                                    </td>
                                    <td style="padding:12px 20px;">
                                        <span class="fluxo-badge ${r.valor >= 0 ? 'fluxo-badge-receita' : 'fluxo-badge-despesa'}">
                                            ${r.tipo}
                                        </span>
                                    </td>
                                    <td style="padding:12px 20px; font-weight:500;">${r.desc} <span style="font-weight:400; color:#94a3b8; font-size:0.8em;">${r.doc !== '-' ? '(' + r.doc + ')' : ''}</span></td>
                                    <td style="padding:12px 20px; text-align:right; font-family:'Courier New', monospace; font-weight:600; ${r.valor >= 0 ? 'color:#166534' : 'color:#dc2626'}">
                                        ${formatBRL(r.valor)}
                                    </td>
                                    <td style="padding:12px 20px; text-align:right; font-weight:700; color:#0f172a;">
                                        ${formatBRL(r.saldoAcumulado)}
                                    </td>
                                </tr>
                            `).join('')}
                            ${rows.length === 0 ? '<tr><td colspan="6" style="padding:20px; text-align:center; color:#94a3b8;">Nenhum registro neste período.</td></tr>' : ''}
                        </tbody>
                    </table>
                </div>
            </div>
        `;

        container.innerHTML = html;

        // Events
        container.querySelector('#btn-update-fluxo').addEventListener('click', () => {
            const s = container.querySelector('#fluxo-start').value;
            const e = container.querySelector('#fluxo-end').value;
            this.loadAndRenderFluxo(container, s, e);
        });

        // Chart Logic (using Chart.js)
        this.renderFluxoChart(container, rows);
    },

    renderFluxoChart: function (container, rows) {
        if (!rows || rows.length === 0) return;

        const ctx = container.querySelector('#fluxoMainChart')?.getContext('2d');
        if (!ctx) return;

        // Prepare Data
        const labels = rows.map(r => r.data.split('-').reverse().slice(0, 2).join('/')); // DD/MM
        const data = rows.map(r => r.saldoAcumulado);

        // Find index where projection starts (first Item that is 'Projetado')
        const firstProjectedIndex = rows.findIndex(r => r.status === 'Projetado');
        const todayIndex = firstProjectedIndex === -1 ? rows.length - 1 : firstProjectedIndex - 1;

        // Destroy old chart if exists (we don't store instance globally easily because of module structure, 
        // but since we re-render the whole HTML, the canvas is new, so no need to destroy old instance on *new* canvas.
        // If we re-used canvas, we would need to.)

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Saldo',
                    data: data,
                    borderColor: '#0f172a',
                    borderWidth: 2,
                    tension: 0.3,
                    fill: {
                        target: 'origin',
                        above: 'rgba(16, 185, 129, 0.05)',
                        below: 'rgba(239, 68, 68, 0.05)'
                    },
                    pointRadius: 3,
                    pointBackgroundColor: ctx => {
                        const idx = ctx.dataIndex;
                        // If logic for Today is simpler: compare date?
                        // Let's rely on the passed status logic
                        return (rows[idx].status === 'Realizado') ? '#0f172a' : '#fff';
                    },
                    pointBorderColor: '#0f172a',
                    segment: {
                        borderColor: ctx => (rows[ctx.p0DataIndex]?.status === 'Projetado' || rows[ctx.p1DataIndex]?.status === 'Projetado') ? '#94a3b8' : '#0f172a',
                        borderDash: ctx => (rows[ctx.p0DataIndex]?.status === 'Projetado' || rows[ctx.p1DataIndex]?.status === 'Projetado') ? [5, 5] : undefined,
                    }
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const val = context.raw.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                const r = rows[context.dataIndex];
                                return `${r.status}: ${val}`;
                            }
                        }
                    },
                    annotation: {
                        // If we want the plugin, we assume it's loaded. But user used CDN for it in mockup.
                        // We checked index.html and ONLY Chart.js is there. No annotation plugin.
                        // So we skip annotations for now to avoid crashes.
                    }
                },
                scales: {
                    y: {
                        grid: { borderDash: [5, 5], color: '#e2e8f0' },
                        ticks: { callback: (val) => val.toLocaleString('pt-BR', { compact: 'short', style: 'currency', currency: 'BRL' }) }
                    },
                    x: { grid: { display: false } }
                }
            }
        });
    }

});
